/**
 * SCRUM-289 (épica SCRUM-279 "Nichos dinámicos") — módulos activos del
 * tenant actual + catálogo de nav_paths por módulo. Cache en memoria (TTL
 * 2 min, mismo criterio que profile-nav-config.ts) — solo importa para
 * tenants con 2+ módulos, la inmensa mayoría hoy tiene 1 y este fetch no
 * cambia su nav en absoluto (ver navItemsForRole en app-nav.ts).
 */
import { apiGetJson } from "@/lib/sm-api";

export type TenantModulesNav = { moduleIds: string[]; moduleNavPaths: Record<string, string[]> };

const cache = { data: null as TenantModulesNav | null, at: 0, tenantId: null as string | null };

export async function fetchTenantModulesNav(tenantId: string): Promise<TenantModulesNav> {
  if (cache.data && cache.tenantId === tenantId && Date.now() - cache.at < 120_000) {
    return cache.data;
  }
  const data = await apiGetJson<TenantModulesNav>("/api/tenant-modules-nav", tenantId);
  cache.data = data;
  cache.at = Date.now();
  cache.tenantId = tenantId;
  return data;
}
